module.exports = __webpack_public_path__ + "static/img/cp_5.39ae444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/cp_5.png
// module id = YoKW
// module chunks = 1